import { useCallback, useEffect } from 'react';
import { useLazyQuery } from '@grandvisionhq/graphql';
import { useDispatch } from '@grandvisionhq/state';
import { isNil } from '@grandvisionhq/utils';
import { GET_PRESCRIPTION_VALUES_FROM_DOCUMENT } from '../PrescriptionUploadResult/operations/queries/get-prescription-values-from-document.js';
import { updatePrescriptionRecognitionValues } from '../../../state/configurations/actions.js';

function useGetPrescriptionValues(frameSku) {
    const dispatch = useDispatch();
    const [execute, { data , loading  }] = useLazyQuery(GET_PRESCRIPTION_VALUES_FROM_DOCUMENT);
    const fetchPrescriptionValues = useCallback((storageId, storageToken)=>{
        if (frameSku && storageId && storageToken) {
            execute({
                variables: {
                    prescriptionDocument: {
                        storageId,
                        storageToken
                    }
                },
                // Recognition needs more time to analyze the prescription
                context: {
                    timeout: 2 * 60000
                }
            });
        }
    }, [
        execute,
        frameSku
    ]);
    useEffect(()=>{
        if (frameSku && data) {
            const { prescriptionValues  } = data.getPrescriptionValuesFromDocument;
            if (prescriptionValues) {
                dispatch(updatePrescriptionRecognitionValues({
                    frameSku,
                    left: removeNullResults(prescriptionValues.leftLens),
                    right: removeNullResults(prescriptionValues.rightLens)
                }));
            }
        }
    // @TODO: else if (error)
    }, [
        data,
        dispatch,
        frameSku
    ]);
    return [
        fetchPrescriptionValues,
        loading
    ];
}
function removeNullResults(data) {
    const result = {};
    for (const [key, value] of Object.entries(data)){
        if (key !== '__typename' && !isNil(value)) {
            result[key] = value;
        }
    }
    return result;
}

export { useGetPrescriptionValues };
//# sourceMappingURL=use-get-prescription-values.js.map
